export class PobierzStatystykiPracownikowFiltr {
  imie: string;
  nazwisko: string;
  zespol: string;
  spisaneGniazda: string;
  spisaneIndeksy: string;
  spisaneSztuki: string;
  spisaneSrodki: string;
  idProjektu: string;
}
